import { validateForUI } from 'common/helpers/jsonValidator';

const creditCardSchema = {
  type: 'object',
  properties: {
    customerCreditCardId: { type: 'string', format: 'uuid' }
  },
  required: ['customerCreditCardId'],
  additionalProperties: false
};

export const validateCreditCard = (creditCard) => {
  const errors = validateForUI(creditCardSchema, creditCard);
  return errors;
};
